var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-grouped-dropdown',{attrs:{"data":_vm.a,"variant":"link","key_label":"name","url":_vm.Url},on:{"dd-item-clicked":_vm.emited},scopedSlots:_vm._u([{key:"drop_down_item",fn:function(ref){
var item = ref.item;
return [_c('div',[_vm._v("\n        "+_vm._s(item.name)+"\n        "),_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}})])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }